/* eslint-disable react/prop-types */
import React from 'react'
import { StyleSheet, View, Image } from 'react-native'

const CardSlots = (props) => {
  return (
        <View id="cardslots" styles={styles.container}>
            {
              cardSlotData.map((val, i) => {
                return <View key={'cardslot' + i} style={[styles.cardslot, {
                  top: val.y,
                  left: val.x
                }]}>
                  { val.c.includes(props.color) &&
                    <Image style={styles.hotspot} source={require('./hexagonal_hotspot.png')}></Image>
                  }
                </View>
              })
            }
        </View>
  )
}

export default CardSlots

const styles = StyleSheet.create({
  container: {
    draggable: 'false',
    pointerEvents: 'none',
    userSelect: 'none'
  },
  cardslot: {
    position: 'absolute',
    height: 125,
    width: 139
  },
  hotspot: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: 125,
    width: 139
  }
})

export const getOverlappingCardSlotIndex = (x, y) => {
  for (let index = 0; index < cardSlotData.length; index++) {
    const slot = cardSlotData[index]
    if (!(x < slot.x || x > (slot.x + styles.cardslot.width) || y < slot.y || y > (slot.y + styles.cardslot.height))) { return index }
  }
  return -1
}

export const getCardSlotData = (index) => {
  if (index > -1) { return cardSlotData[index] } else {
    return { x: 0, y: 0, p: '', c: [] }
  }
}

export const getNumCardSlots = () => {
  return cardSlotData.length
}

const cardSlotData = [
  {
    y: 174,
    x: 145,
    c: ['b'],
    p: 'Traffic'
  },
  {
    y: 111,
    x: 33,
    c: ['b'],
    p: 'Traffic'
  },
  {
    y: 110,
    x: 254,
    c: ['b'],
    p: 'Traffic'
  },
  {
    y: 45,
    x: 141,
    c: ['b', 'y'],
    p: 'Traffic'
  },
  {
    y: 334,
    x: 139,
    c: ['r'],
    p: 'Public'
  },
  {
    y: 527,
    x: 33,
    c: ['y'],
    p: 'Public'
  },
  {
    y: 401,
    x: 32,
    c: ['r', 'b'],
    p: 'Public'
  },
  {
    y: 459,
    x: 139,
    c: ['y', 'r'],
    p: 'Public'
  },
  {
    y: 20,
    x: 529,
    c: ['y', 'r'],
    p: 'Wastes'
  },
  {
    y: 44,
    x: 808,
    c: ['r'],
    p: 'Private'
  },
  {
    y: 108,
    x: 916,
    c: ['r', 'b'],
    p: 'Private'
  },
  {
    y: 44,
    x: 1026,
    c: ['b', 'y'],
    p: 'Private'
  },
  {
    y: 173,
    x: 1024,
    c: ['r'],
    p: 'Private'
  },
  {
    y: 235,
    x: 916,
    c: ['y'],
    p: 'Private'
  },
  {
    y: 434,
    x: 1028,
    c: ['r'],
    p: 'Energy'
  },
  {
    y: 497,
    x: 920,
    c: ['y'],
    p: 'Energy'
  }]
